import { css } from '@emotion/react';
import { useInvoicePerson } from '@frontend/payments-collection-flow';
import { useGetInvoiceQuery } from '@frontend/payments-invoice-controller';
import { useChargesEnabledLocations } from '@frontend/person-invoice-create';
import { theme } from '@frontend/theme';
import { BannerNotification, ContentLoader } from '@frontend/design-system';
import { usePaymentNavigateWithAlert } from '../../hooks/navigation-alert/use-payment-navigate-with-alert';
import { PaymentsNavAlerts } from '../../utils/helpers';
import { Details } from './Details';
import { PaymentInformationTable } from './payment-information-table';
import { PaymentRequestActivityCard } from './payment-request-activity-card';
import { PaymentRequestAttachment } from './payment-request-attachment';
import { PaymentRequestNotes } from './payment-request-notes';
import { SummaryCard } from './SummaryCard';

export const PaymentRequestDetailsPage = ({ selectedInvoiceId }: { selectedInvoiceId: string | undefined }) => {
  const { invoice, isLoading, isFetched } = useGetInvoiceQuery(selectedInvoiceId);
  const { person, personEmail } = useInvoicePerson(invoice);
  const { disabledMessageWithLink } = useChargesEnabledLocations({ locationIds: [invoice?.locationId] });

  usePaymentNavigateWithAlert({
    enable: isFetched && !isLoading && !invoice,
    key: PaymentsNavAlerts.InvalidInvoice,
    to: { to: '/payments/invoices' },
  });

  return (
    <>
      <ContentLoader show={isLoading} />
      {!isLoading && !!invoice && (
        <>
          {disabledMessageWithLink && (
            <BannerNotification
              css={css`
                margin-bottom: ${theme.spacing(2)};
              `}
              status='error'
            >
              {disabledMessageWithLink}
            </BannerNotification>
          )}
          <SummaryCard invoice={invoice} />
          <Details invoice={invoice} personEmail={personEmail} />
          <PaymentInformationTable invoice={invoice} />
          <PaymentRequestAttachment invoice={invoice} person={person} />
          <PaymentRequestActivityCard invoiceId={invoice?.id} locationId={invoice?.locationId} />
          <PaymentRequestNotes invoice={invoice} />
        </>
      )}
    </>
  );
};
